var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYolohDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_131859",
    "data-name": "Group 131859",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 237.262,
    height: 59.639,
    viewBox: "0 0 237.262 59.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6005",
    "data-name": "Rectangle 6005",
    width: 237.262,
    height: 59.639,
    fill: "#567791"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128565",
    "data-name": "Group 128565",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91125",
    "data-name": "Path 91125",
    d: "M292.852,2.142a2.141,2.141,0,0,0-2.7-2.067c-4.08,1.1-10.3,2.819-13.478,3.7-3.028.837-3.551,1.632-3.551,4.366,0,.281,0,34.957,0,35.79h0c0,7.537,0,13.567,0,13.567a2.141,2.141,0,0,0,2.7,2.067c4.08-1.1,10.3-2.819,13.478-3.7,3.028-.837,3.551-1.632,3.551-4.366,0-.281,0-49.357,0-49.357",
    transform: "translate(-164.376 0)",
    fill: "#567791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91126",
    "data-name": "Path 91126",
    d: "M182.729,36.9c0-26-25.04-25.106-25.04-25.106S132.622,10.88,132.622,36.9s25.067,25.179,25.067,25.179,25.04.824,25.04-25.179m-25.083,12.64c-3.81,0-3.992-6.6-3.992-8.817V33.152c0-2.221.17-8.817,4.022-8.817s4.022,6.6,4.022,8.817v7.572c0,2.221-.243,8.817-4.052,8.817",
    transform: "translate(-79.817 -7.097)",
    fill: "#567791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91127",
    "data-name": "Path 91127",
    d: "M387.4,36.9c0-26-25.04-25.106-25.04-25.106S337.289,10.88,337.289,36.9s25.067,25.179,25.067,25.179,25.04.824,25.04-25.179m-25.083,12.64c-3.81,0-3.992-6.6-3.992-8.817V33.152c0-2.221.17-8.817,4.022-8.817s4.022,6.6,4.022,8.817v7.572c0,2.221-.243,8.817-4.052,8.817",
    transform: "translate(-202.993 -7.097)",
    fill: "#567791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91128",
    "data-name": "Path 91128",
    d: "M14.419,53.488c6.473,0,10.865-3.31,12.8-6.22a20.656,20.656,0,0,0,2.622-5.612c.178-.553.363-.92.848-.92.639,0,.642.579.585,1.079a18.221,18.221,0,0,1-1.042,4.21C29.146,49,27.312,52.98,27.312,58.5v6.836a2.141,2.141,0,0,0,2.7,2.067c4.08-1.1,10.3-2.819,13.478-3.7,3.028-.837,3.551-1.632,3.551-4.366s-.028-34.186-.029-44.161a2.138,2.138,0,0,0-2.139-2.139H29.442A2.139,2.139,0,0,0,27.3,15.178c.006,4.106.007,15.111.007,18.066,0,5.893-2.454,8.277-4.554,8.277s-2.982-1.666-2.982-3.742v-22.6a2.138,2.138,0,0,0-2.139-2.139H2.183a2.14,2.14,0,0,0-2.14,2.133C.03,18.948,0,27.143,0,38.46,0,50.777,8.658,53.488,14.419,53.488",
    transform: "translate(0 -7.845)",
    fill: "#567791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91129",
    "data-name": "Path 91129",
    d: "M510.37,14.037c-6.473,0-10.865,3.31-12.8,6.22a20.66,20.66,0,0,0-2.622,5.612c-.178.553-.363.92-.848.92-.639,0-.642-.579-.585-1.079a18.193,18.193,0,0,1,1.042-4.21c1.083-2.976,2.917-6.955,2.917-12.472V2.193a2.141,2.141,0,0,0-2.7-2.067c-4.079,1.1-10.3,2.819-13.478,3.7-3.028.837-3.551,1.632-3.551,4.366s.029,34.186.029,44.16a2.139,2.139,0,0,0,2.139,2.139h15.432a2.139,2.139,0,0,0,2.139-2.143c-.006-4.106-.007-15.111-.007-18.066,0-5.893,2.454-8.277,4.554-8.277s2.982,1.666,2.982,3.742v22.6a2.138,2.138,0,0,0,2.139,2.139h15.453a2.14,2.14,0,0,0,2.14-2.133c.013-3.78.043-11.975.043-23.292,0-12.317-8.658-15.028-14.419-15.028",
    transform: "translate(-287.526 -0.03)",
    fill: "#567791"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolohDarkLogo);
export default __webpack_public_path__ + "static/media/yoloh-dark-logo.c8121ec5e2f8880dc1beb08d6f638792.svg";
export { ForwardRef as ReactComponent };